import React from "react";
import {
    FeedEntrypointContainer,
    FeedItemContentContainer,
    FeedSublineTypography,
    FeedTitleContainer,
    FeedTitleTypography,
    GroupAvatar,
} from "./PostListModalHeader.styles";
import { UsersIcon } from "@icons/UsersIcon";
import { avatarFallbackColorSelector } from "@shared/Avatar/AvatarFallbackColorSelector";
import { UserAvatarFactory } from "../../../../UserAvatar/UserAvatarFactory";
import { GroupInput } from "@shared/Types/GroupEntry.types";

export function PostListModalHeader({ groupData }: { groupData: GroupInput }) {
    const avatarOptions = {
        avatar: groupData?.avatar,
        gender: undefined,
        uuid: undefined,
        fallbackIcon: <UsersIcon />,
        component: GroupAvatar,
        sx: {
            color: avatarFallbackColorSelector(""),
        },
    };
    return (
        <FeedEntrypointContainer>
            {groupData.showAvatar && UserAvatarFactory(avatarOptions)}
            <FeedItemContentContainer>
                <FeedTitleContainer>
                    <FeedTitleTypography className={"fontFamily-inherited"}>
                        {groupData?.title}
                    </FeedTitleTypography>
                </FeedTitleContainer>
                <FeedTitleContainer>
                    <FeedSublineTypography className={"fontFamily-inherited"}>
                        {groupData?.usersCount}
                    </FeedSublineTypography>
                </FeedTitleContainer>
            </FeedItemContentContainer>
        </FeedEntrypointContainer>
    );
}
